import { render } from "./GrayBlock.vue?vue&type=template&id=ffbea006&scoped=true"
const script = {}

import "./GrayBlock.vue?vue&type=style&index=0&id=ffbea006&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbea006"]])

export default __exports__